import { reactive } from 'vue'

export type NotificationStatus = 'success' | 'info' | 'warning' | 'error'

export interface NotificationItem {
  id: number
  status: NotificationStatus
  title?: string
  message: string
  durationMs: number
  createdAt: number
}

const state = reactive<{ items: NotificationItem[] }>({ items: [] })
let nextId = 1

export function notify(opts: { status?: NotificationStatus; message: string; title?: string; durationMs?: number }): { id: number; dismiss: () => void } {
  const id = nextId++
  const item: NotificationItem = {
    id,
    status: opts.status || 'info',
    title: opts.title,
    message: opts.message,
    durationMs: Math.max(1000, Math.min(30000, opts.durationMs ?? 4000)),
    createdAt: Date.now(),
  }
  state.items.unshift(item)
  const t = setTimeout(() => remove(id), item.durationMs)
  return {
    id,
    dismiss: () => {
      clearTimeout(t)
      remove(id)
    },
  }
}

export function remove(id: number) {
  const idx = state.items.findIndex((n) => n.id === id)
  if (idx !== -1) state.items.splice(idx, 1)
}

export function useNotifications() {
  return state
}

export const notifySuccess = (message: string, title?: string, durationMs?: number) => notify({ status: 'success', message, title, durationMs })
export const notifyInfo = (message: string, title?: string, durationMs?: number) => notify({ status: 'info', message, title, durationMs })
export const notifyWarning = (message: string, title?: string, durationMs?: number) => notify({ status: 'warning', message, title, durationMs })
export const notifyError = (message: string, title?: string, durationMs?: number) => notify({ status: 'error', message, title, durationMs })


